import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

/**
 * Tracks page views on route changes for React Router (SPA).
 * Must be rendered inside <Router>.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Send page view on route change
    const path = location.pathname + location.search;
    ReactGA.send({ hitType: "pageview", page: path });
  }, [location]);

  return null;
}
